import landingRU from "./landing/ru.json"
import landingEN from "./landing/en.json"
import landingDE from "./landing/de.json"
import landingNL from "./landing/nl.json"
import landingIT from "./landing/it.json"

import discoverRU from "./discover/en.json"
import discoverEN from "./discover/en.json"

import dashboardRU from "./dashboard/ru.json"
import dashboardEN from "./discover/en.json"

export default {
    landing: {
        RU: landingRU,
        EN: landingEN,
        DE: landingDE,
        NL: landingNL,
        IT: landingIT
    },
    discover: {
        RU: discoverRU,
        EN: discoverEN,
    },
    dashboard: {
        RU: dashboardRU,
        EN: dashboardEN,
    }
}